import { render, staticRenderFns } from "./BaseSearchListPage.vue?vue&type=template&id=22b8cef2&scoped=true&"
import script from "./BaseSearchListPage.vue?vue&type=script&lang=js&"
export * from "./BaseSearchListPage.vue?vue&type=script&lang=js&"
import style0 from "./BaseSearchListPage.vue?vue&type=style&index=0&id=22b8cef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8cef2",
  null
  
)

export default component.exports